import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {dateFormatter} from "../../../_metronic/_helpers";
import {ImageUploadModal} from "../../widgets";
import {useDispatch, useSelector} from "react-redux";
import {uploadProfilePic} from "../../redux_slices/userParametersSlice";
import {CircularProgress} from "@material-ui/core";

const DetailLateralComponent = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [placeholderUploadImg, setPlaceholderUploadImg] = useState("");
    const [openUploadImageModal, setOpenUploadImageModal] = useState({
        open: false,
        type: "",
    });

    const user = useSelector(state => state.userParameters.credential);
    const userParametersStatus = useSelector(state => state.userParameters.status);

    const onAvatarChange = async ({file, onConfirmUploaded, onError}) => {
        if (file) {
            let formData = new FormData();
            formData.append("avatar", file);

            await dispatch(uploadProfilePic({formData}));
            onConfirmUploaded();
        }
    };

    let content;
    if (userParametersStatus.type === "succeeded") {
        content = (
            <div className="d-flex flex-column">
                <img
                    className="border-bottom"
                    src={user?.avatar_url || "/media/avatars/dummy-avatar.jpg"}
                    alt="user profile"
                />
                <div className="d-flex flex-column align-items-center p-5 pt-7">
                    <h3 className="font-weight-bolder">
                        {user?.name && user?.surname ? `${user?.name} ${user?.surname}` : "Profile"}
                    </h3>
                    <ul className="list-unstyled mb-4">
                        <li className="my-3">
                            <strong>{t("GENERAL.CREATED_AT")}</strong> {dateFormatter(user?.created_at)}
                        </li>
                        <li className="my-3">
                            <strong>{t("GENERAL.UPDATED_AT")}</strong> {dateFormatter(user?.updated_at)}
                        </li>
                    </ul>
                    <button
                        className="btn btn-primary flex-grow-1"
                        onClick={() => {
                            setPlaceholderUploadImg(user?.avatar_url || "/media/avatars/dummy-avatar.jpg");
                            setOpenUploadImageModal({open: true, type: ""});
                        }}
                    >
                        {t("TOOLTIP.EDIT.IMAGE")}
                    </button>
                </div>
            </div>
        );
    } else {
        content = (
            <div className="d-flex align-items-center justify-content-center">
                <CircularProgress />
            </div>
        );
    }

    return (
        <div className="card card-custom mb-5 overflow-hidden">
            <div className="card-body p-0">{content}</div>
            {/* upload image: */}
            <ImageUploadModal
                onUpload={onAvatarChange}
                open={openUploadImageModal}
                setOpen={setOpenUploadImageModal}
                placeholder={placeholderUploadImg}
            />
        </div>
    );
};

export default DetailLateralComponent;
